/**
 * Design tokens for the Claims review cards. Kept in sync with the Team Feed
 * review card (pages/Feed/FeedReviewCard) so a claimed review reads the same
 * whether you meet it on the Claims wall or in the feed.
 */
export const T = {
  surface: "#FFFFFF",
  foot: "#FBFCFE",
  line: "#E7E9EE",
  hairline: "#EEF0F4",
  ink: "#0B1320",
  ink2: "#2A3142",
  muted: "#6B7388",
  faint: "#9AA1B0",
  gold: "#F0B33D",
  goldText: "#8A5A05",
  good: "#16A77A",
  goodSoft: "#E9F7F0",
  neutralChip: "#F1F3F7",
};

export const CLAIM_FONT = '"DM Sans", "Inter", sans-serif';

export const SOURCE_META = {
  google: { label: "Google", dot: "#EA4335" },
  facebook: { label: "Facebook", dot: "#1877F2" },
  yelp: { label: "Yelp", dot: "#D32323" },
  review: { label: "Review", dot: "#94A3B8" },
};
